import React from 'react';
import { CustomButton, CustomInputSelect } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import {
  IUsersSupervisionDatatable,
  UsersSupervisionDatatableMeta,
} from './UsersSupervisionDatatableHandlerMeta';

export default function UsersSupervisionDatatableHandler() {
  const editUsersModal = React.useRef<any>(null);
  const deleteUsersModal = React.useRef<any>(null);

  const data: IUsersSupervisionDatatable[] = [
    {
      username: 'ABELLO',
      state: 'Expired',
      createdAt: '02/11/2018',
      lockAt: '',
      expireAt: '09/01/2019',
      profile: 'HPX_PROFILE',
      outSessionLimit: 'yes',
    },
  ];

  const handleEdit = (row: any) => {
    editUsersModal?.current?.onOpen();
  };

  const handleDelete = (row: any) => {
    deleteUsersModal?.current?.onOpen();
  };

  return (
    <>
      <CC.Box>
        <CustomReactTable
          data={data}
          columns={UsersSupervisionDatatableMeta.columns(
            handleEdit,
            handleDelete
          )}
        />
        <CC.Flex justifyContent="flex-end" my="2">
          <CustomButton>Enregistrer</CustomButton>
        </CC.Flex>
      </CC.Box>

      <CustomAppModal
        title="Editer Le Status des utilisateurs"
        ref={editUsersModal}
        actionBtnText="Editer"
        actionBtnClick={() => editUsersModal?.current?.onClose()}
      >
        <CustomFormControl label="Status">
          <CustomInputSelect
            meta={{
              name: 'status',
              options: [
                { label: 'Actif', value: 'active' },
                { label: 'Vérouillé', value: 'lock' },
              ],
            }}
          />
        </CustomFormControl>
      </CustomAppModal>

      <CustomAppModal
        title="Confirmer la suppression"
        ref={deleteUsersModal}
        actionBtnText="Supprimer"
        actionBtnClick={() => deleteUsersModal?.current?.onClose()}
      >
        <CC.Text>Voulez-vous vraiment supprimer ?</CC.Text>
      </CustomAppModal>
    </>
  );
}
